module.exports = __webpack_public_path__ + "static/media/cxBTC.7f5b3a1c.png";